// extracted by mini-css-extract-plugin
module.exports = {"action-btn":"add-to-cart_action-btn__BIkEU","quantity-container":"add-to-cart_quantity-container__K7vpp"};